<template>
<v-tooltip bottom>
  <template v-slot:activator="{ on, attrs }">
    <v-icon
      v-on="on"
      v-bind="attrs"
      :color="statusColor"
    >{{ statusIcon }}</v-icon>
  </template>
  {{ statusTooltip }}
</v-tooltip>
</template>

<script>

export default {
  name: 'StatusMarker',

  props: {
    status: {
      type: String,
    },

    message: {
      type: String,
      default: '',
    },
  },

  computed: {
    isStatusDone() {
      return this.status === this.$constants.API_STATUS.DONE;
    },
    isStatusFailed() {
      return this.status === this.$constants.API_STATUS.FAILED;
    },
    isStatusInProgress() {
      return this.status === this.$constants.API_STATUS.IN_PROGRESS;
    },
    isStatusOther() {
      return !this.isStatusDone && !this.isStatusFailed && !this.isStatusInProgress;
    },

    statusIcon() {
      switch (this.status) {
        case this.$constants.API_STATUS.DONE:
          return 'mdi-check';
        case this.$constants.API_STATUS.IN_PROGRESS:
          return 'mdi-progress-download';
        case this.$constants.API_STATUS.FAILED:
          return 'mdi-alert';
        default:
          return 'mdi-border-none-variant';
      }
    },

    statusColor() {
      switch (this.status) {
        case this.$constants.API_STATUS.DONE:
          return 'green';
        case this.$constants.API_STATUS.IN_PROGRESS:
          return 'orange';
        case this.$constants.API_STATUS.FAILED:
          return 'red';
        default:
          return 'blue';
      }
    },

    statusTooltip() {
      let statusTooltip;

      switch (this.status) {
        case this.$constants.API_STATUS.DONE:
          statusTooltip = 'Done';
          break;
        case this.$constants.API_STATUS.IN_PROGRESS:
          statusTooltip = 'In progress';
          break;
        case this.$constants.API_STATUS.FAILED:
          if (!this.message) {
            statusTooltip = 'Failed';
          } else if (!this.message.startsWith('Failed apiRequest')) {
            statusTooltip = this.message;
          } else {
            const index = this.message.indexOf('error message: ');
            if (index !== -1) {
              statusTooltip = this.message.slice(index + 'error message: '.length);
            } else {
              statusTooltip = 'Failed API request';
            }
          }
          break;
        default:
          statusTooltip = 'Other';
      }

      return statusTooltip;
    },
  },
};
</script>

<style scoped>

</style>
